import Tooltip from "@/tooltip";
import {
	CheckIcon,
	ChevronDownIcon,
	Cog8ToothIcon as CogIcon,
	InformationCircleIcon,
	MinusIcon,
} from "@heroicons/react/20/solid";
import { merge, setWith } from "lodash";
import { useEffect, useState } from "react";
import { connect } from "react-redux";
import Select from "react-select";
import Logo from "./assets/workforce-logo.svg";
import { Actions as WORKFORCE_ACTIONS } from "./store/workforceActions";
import apiURL from "@/apiURL";
const unfinished = false;

const WorkforceSettings = ({
	connected,
	needsVerification,
	// connect,
	connectUrl,
	prevConnected,
	disconnect,
	mappingOptions,
	leaveOptions,
	disabled,
	saving,
	saveWorkforceSettings,
	settings,
}) => {
	const [expand, setExpand] = useState(false);
	const [expandLeave, setExpandLeave] = useState(false);
	const [expandAward, setExpandAward] = useState(false);
	const [data, setData] = useState({});

	const updateField = (field, value) => {
		if (!field) return;
		if (field.includes("[")) field = setWith({}, field, value, Object);
		const newData = merge(data, { ...(typeof field == "object" ? field : { [field]: value }) });
		setData({ ...newData });
	};

	const saveData = (e) => {
		e.preventDefault();
		e.stopPropagation();
		const dataToSend = {
			setBreakAfterMidnight: data.setBreakAfterMidnight,
			splitTimesheetsAtMidnight: data.splitTimesheetsAtMidnight,
			costingMethod: data.costingMethod,
			leaveTypes: Object.entries({ ...data.leaveTypes }).map(([key, value]) => ({
				type: key,
				externalType: value,
			})),
			rounding: data.rounding,
			mappings: Object.entries({ ...data.mappings }).map(([key, value]) => ({ type: key, externalType: value })),
		};

		saveWorkforceSettings(dataToSend);
	};

	useEffect(() => {
		if (settings) {
			const mappings = settings?.mappings?.reduce((prev, curr) => {
				prev[curr.type] = curr.externalType;
				return prev;
			}, {});

			const leaveTypes = settings?.leaveTypes?.reduce((prev, curr) => {
				prev[curr.type] = curr.externalType;
				return prev;
			}, {});

			setData({ ...settings, mappings, leaveTypes });
		}
	}, [settings]);

	if (!connected) {
		return (
			<div className="col-sm-12 integration-row">
				<div className="col-sm-3">
					<img
						src={Logo}
						width="40px"
					/>
					<span style={{ paddingLeft: 20, fontSize: 16 }}>Workforce</span>
				</div>
				<div className="col-sm-9">
					{unfinished ? (
						<div className="btn btn-default pull-right">Coming Soon</div>
					) : (
						<>
							<a
								className="btn btn-primary pull-right"
								style={{ marginTop: 2 }}
								href={connectUrl}
							>
								{prevConnected ? `Reconnect` : `Connect`}
							</a>
						</>
					)}
				</div>
			</div>
		);
	}

	const costingMethodOptions = [
		{
			label: "Buddy",
			value: "buddy",
		},
		{
			label: "Workforce",
			value: "workforce",
		},
	];

	return (
		<div className={`${expand ? "tr-gray" : ""} col-xs-12 integration-row`}>
			<div className="col-sm-3">
				<img
					src={Logo}
					width="40px"
				/>
				<span style={{ paddingLeft: 20, fontSize: 16 }}>Workforce</span>
			</div>
			<div className="col-xs-9">
				<div
					className="btn btn-default pull-right"
					style={{ paddingRight: 6 }}
					onClick={() => setExpand(!expand)}
				>
					<CogIcon style={{ height: "1.5em", float: "left" }} />
					<div style={{ float: "left", marginLeft: 5, marginRight: 5 }}>Settings</div>
					<ChevronDownIcon
						style={{
							height: "1.5em",
							float: "left",
							transform: expand ? "rotate(180deg)" : "rotate(0deg)",
							transition: "transform 0.2s ease-in-out",
						}}
					/>
				</div>
				<button
					className={`btn ${needsVerification ? "btn-primary" : "btn-default"} pull-right`}
					style={{ marginRight: 10 }}
				>
					<CheckIcon style={{ height: "1.5em", float: "left" }} />
					<div style={{ float: "left", marginLeft: 5, marginRight: 5 }}>Connected</div>
				</button>
			</div>
			<div className="col-xs-12">
				{expand ? (
					<form>
						<div
							className="row"
							style={{ padding: 0, paddingRight: "1.5rem" }}
						>
							<button
								className="btn btn-primary pull-right"
								onClick={(e) => {
									e.preventDefault();
									e.stopPropagation();
									disconnect();
								}}
							>
								<MinusIcon style={{ height: "1.5em", float: "left" }} />
								<div style={{ float: "left", marginLeft: 5 }}>Disconnect</div>
							</button>
						</div>

						<div className="col-xs-3">
							<label>Costing Method </label>
							<Select
								id="costingMethod"
								name="costingMethod"
								value={
									data?.costingMethod
										? costingMethodOptions.find((m) => m.value == data?.costingMethod)
										: costingMethodOptions[0]
								}
								options={costingMethodOptions}
								isDisabled={disabled}
								onChange={(e) => {
									updateField("costingMethod", e?.value || null);
								}}
							/>
						</div>
						<div className="clearfix" />

						<div className="form-inner-section">
							<h4>
								Rounding{" "}
								<Tooltip
									as="span"
									className="w-7 h-7 text-primary"
									content="This only works if a roster can be found for the same day."
								>
									<InformationCircleIcon className="h-5 w-5" />
								</Tooltip>
							</h4>

							<div className="col-xs-8">
								<p
									className="form-material"
									style={{ marginBottom: "0.5rem" }}
								>
									When an employee is up to{" "}
									<input
										id={`rounding[startTimeEarly]`}
										name={`rounding[startTimeEarly]`}
										className="form-control form-input form-xs-2"
										style={{ width: "50px", display: "inline-block", textAlign: "center" }}
										value={data.rounding?.startTimeEarly}
										aria-required="false"
										autoComplete="off"
										disabled={saving || disabled}
										onChange={(e) => {
											updateField(e.target.name, e.target.value);
										}}
									/>{" "}
									minutes early to their shift, round to rostered time in.
								</p>
							</div>
							<div className="col-xs-8 pr-0 ">
								<p
									className="form-material"
									style={{ marginBottom: "0.5rem" }}
								>
									When an employee is up to{" "}
									<input
										id={`rounding[startTimeLate]`}
										name={`rounding[startTimeLate]`}
										className="form-control form-input form-xs-2"
										style={{ width: "50px", display: "inline-block", textAlign: "center" }}
										value={data.rounding?.startTimeLate}
										aria-required="false"
										autoComplete="off"
										disabled={saving || disabled}
										onChange={(e) => {
											updateField(e.target.name, e.target.value);
										}}
									/>{" "}
									minutes late to their shift, round to rostered time in.{" "}
								</p>
							</div>
							<div className="col-xs-8 pr-0">
								<p
									className="form-material"
									style={{ marginBottom: "0.5rem" }}
								>
									When an employee leaves to{" "}
									<input
										id={`rounding[endTimeEarly]`}
										name={`rounding[endTimeEarly]`}
										className="form-control form-input form-xs-2"
										style={{ width: "50px", display: "inline-block", textAlign: "center" }}
										value={data.rounding?.endTimeEarly}
										aria-required="false"
										autoComplete="off"
										disabled={saving || disabled}
										onChange={(e) => {
											updateField(e.target.name, e.target.value);
										}}
									/>{" "}
									minutes early to their shift, round to rostered time in.{" "}
								</p>
							</div>
							<div className="col-xs-8 pr-0">
								<p
									className="form-material"
									style={{ marginBottom: "0.5rem" }}
								>
									When an employee leaves to{" "}
									<input
										id={`rounding[endTimeLate]`}
										name={`rounding[endTimeLate]`}
										className="form-control form-input form-xs-2"
										style={{ width: "50px", display: "inline-block", textAlign: "center" }}
										value={data.rounding?.endTimeLate}
										aria-required="false"
										autoComplete="off"
										disabled={saving || disabled}
										onChange={(e) => {
											updateField(e.target.name, e.target.value);
										}}
									/>{" "}
									minutes late to their shift, round to rostered time in.{" "}
								</p>
							</div>

							<div className="clearfix" />
							<h4>Timesheet Settings</h4>

							<div className="col-xs-4 pr-0">
								<label className="col-xs-6 pr-0 css-input switch switch-sm switch-success">
									<input
										id="setBreakAfterMidnight"
										name="setBreakAfterMidnight"
										checked={data?.setBreakAfterMidnight}
										type="checkbox"
										disabled={disabled}
										onChange={(e) => updateField(e.target.name, e.target.checked)}
									/>
									<span />
									Set Break After Midnight
									<Tooltip
										as="div"
										className="h-7 w-7 text-primary"
										content="This may be required if you pay different rates based on day of the week (e.g. Sundays, Public Holidays) and you want to pay your staff consistently, regardless of when they took their break (especially if break times are not tracked)."
									>
										<InformationCircleIcon className="h-5 w-5" />
									</Tooltip>
								</label>
							</div>

							<div className="col-xs-4 pr-0">
								<label className="col-xs-6 pr-0 css-input switch switch-sm switch-success">
									<input
										id="splitTimesheetsAtMidnight"
										name="splitTimesheetsAtMidnight"
										checked={data?.splitTimesheetsAtMidnight}
										type="checkbox"
										disabled={disabled}
										onChange={(e) => updateField(e.target.name, e.target.checked)}
									/>
									<span />
									Split Timesheets At Midnight
									<Tooltip
										as="div"
										className="h-7 w-7 text-primary"
										content="If you want all your cutoffs to be midnight, this needs to be enabled. Otherwise, the whole shift will counted on the first day. This may impact your overtime calculations."
									>
										<InformationCircleIcon className="h-5 w-5" />
									</Tooltip>
								</label>
							</div>
							<div className="clearfix" />
						</div>

						<div className="clearfix" />

						<div className="form-inner-section">
							<div className="col-xs-12 pl-0">
								<div className="col-xs-6 pl-0">
									<h4 style={{ display: "block", width: "min-content", textWrap: "nowrap" }}>
										Award Mapping
									</h4>
								</div>
								<button
									type="button"
									className="btn btn-xs btn-default pull-right"
									onClick={() => setExpandAward(!expandAward)}
								>
									<ChevronDownIcon
										style={{
											height: "1.5em",
											float: "left",
											transform: expandAward ? "rotate(180deg)" : "rotate(0deg)",
											transition: "transform 0.2s ease-in-out",
										}}
									/>
								</button>
							</div>
							<div className="clearfix" />
							{expandAward &&
								mappingOptions?.map((allowance) => (
									<>
										<div
											className="col-xs-6"
											key={allowance.id}
										>
											<label>{allowance.name} - Buddy</label>
											<Select
												isDisabled
												name={`${allowance.id}[buddy]`}
												value={allowance}
											/>
											<div className="clearfix" />
										</div>

										<div className="col-xs-6 pr-0">
											<label htmlFor={`mappings[${allowance.id}]`}>
												{allowance.name} - Workforce
											</label>
											<div
												className="form-container form-material"
												style={{ marginTop: 0 }}
											>
												<input
													id={`mappings[${allowance.id}]`}
													name={`mappings[${allowance.id}]`}
													className="form-control form-input"
													value={data[allowance.id]?.name}
													defaultValue={
														settings?.mappings?.find((m) => m.type == allowance.id)
															?.externalType
													}
													aria-required="true"
													autoComplete="off"
													disabled={saving || disabled}
													onChange={(e) => {
														updateField(e.target.name, e.target.value);
													}}
												/>
											</div>
										</div>
										<div className="clearfix" />
									</>
								))}
						</div>

						<div className="form-inner-section">
							<div className="col-xs-12 pl-0">
								<div className="col-xs-6 pl-0">
									<h4 style={{ display: "block", width: "min-content", textWrap: "nowrap" }}>
										Leave Mapping
									</h4>
								</div>
								<button
									type="button"
									className="btn btn-xs btn-default pull-right"
									onClick={() => setExpandLeave(!expandLeave)}
								>
									<ChevronDownIcon
										style={{
											height: "1.5em",
											float: "left",
											transform: expandLeave ? "rotate(180deg)" : "rotate(0deg)",
											transition: "transform 0.2s ease-in-out",
										}}
									/>
								</button>
							</div>
							{expandLeave &&
								leaveOptions?.map((leave) => (
									<>
										<div
											className="col-xs-6"
											key={leave.id}
										>
											<label>{leave.name} - Buddy</label>
											<Select
												isDisabled
												name={`${leave.id}[buddy]`}
												value={leave}
											/>
											<div className="clearfix" />
										</div>

										<div className="col-xs-6 pr-0">
											<label htmlFor={`leaveTypes[${leave.id}]`}>{leave.name} - Workforce</label>
											<div
												className="form-container form-material"
												style={{ marginTop: 0 }}
											>
												<input
													id={`leaveTypes[${leave.id}]`}
													name={`leaveTypes[${leave.id}]`}
													className="form-control form-input"
													value={data[leave.id]?.name}
													defaultValue={
														settings?.leaveTypes?.find((m) => m.type == leave.id)
															?.externalType
													}
													aria-required="true"
													autoComplete="off"
													disabled={saving || disabled}
													onChange={(e) => {
														updateField(e.target.name, e.target.value);
													}}
												/>
											</div>
										</div>
									</>
								))}
							<div className="clearfix" />
						</div>
						<div className="clearfix" />

						<div className="pull-right">
							{!disabled && (
								<button
									className="btn btn-success"
									type="submit"
									disabled={disabled || saving}
									onClick={saveData}
								>
									{(saving && "Saving...") || "Save"}
								</button>
							)}
						</div>
					</form>
				) : null}
			</div>
		</div>
	);
};

const mapStateToProps = (state) => {
	const { tanda } = state?.integration?.timeAttendance || {};

	const mappingOptions = [
		...(state.company?.settings?.allowances || []),
		...(state.company?.settings?.overtimes || []),
	].map((a) => ({ ...a, value: a.id, label: a.name }));

	const leaveOptions = (state.leave?.leaveTypes || [])
		.filter((l) => !l.temporary)
		.map((l) => ({ ...l, value: l.id, label: l.name }));

	const settings = {
		...tanda?.settings,
		costingMethod: tanda?.costingMethod,
		rounding: tanda?.rounding,
		setBreakAfterMidnight: tanda?.setBreakAfterMidnight,
		splitTimesheetsAtMidnight: tanda?.splitTimesheetsAtMidnight,
	};

	return {
		mappingOptions,
		leaveOptions,
		settings,
		connected: tanda?.connected ?? false,
		connectUrl: tanda?.connectUrl ?? apiURL + "/integrations/tanda/new",
		prevConnected: !!tanda,
	};
};

const mapDispatchToProps = (dispatch) => ({
	// connect: () => dispatch(WORKFORCE_ACTIONS.connectWorkforce()),
	disconnect: () => dispatch(WORKFORCE_ACTIONS.disconnectWorkforce()),
	saveWorkforceSettings: (data) => dispatch(WORKFORCE_ACTIONS.saveWorkforceSettings(data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(WorkforceSettings);
